/**
 * Status options and mappings for billing tabs
 */

// Encounter status options (direct statuses from new org-scoped endpoint)
export const ENCOUNTER_STATUS_OPTIONS = [
  { value: 'pending', label: 'Pending', color: 'default' as const },
  { value: 'processing', label: 'Processing', color: 'info' as const },
  { value: 'completed', label: 'Completed', color: 'success' as const },
] as const;

// Claim filter options (for encounters tab — has_claim filter)
export const CLAIM_FILTER_OPTIONS = [
  { value: 'true', label: 'With Claim', color: 'primary' as const },
  { value: 'false', label: 'Without Claim', color: 'default' as const },
] as const;

// Billable filter options
export const BILLABLE_FILTER_OPTIONS = [
  { value: 'true', label: 'Billable', color: 'success' as const },
  { value: 'false', label: 'Not Billable', color: 'default' as const },
] as const;

// Ready to bill filter options (for encounters tab)
export const READY_TO_BILL_FILTER_OPTIONS = [
  { value: 'green', label: 'Ready', color: 'success' as const },
  { value: 'yellow', label: 'Needs Review', color: 'warning' as const },
  { value: 'red', label: 'Blocked', color: 'error' as const },
] as const;

// Claims Tab statuses (from API)
export type ClaimStatus =
  | 'draft' | 'processing' | 'failed' | 'scrubbing' | 'ready'
  | 'submitted' | 'acknowledged' | 'accepted' | 'rejected'
  | 'paid' | 'partially_paid' | 'denied' | 'reversed';

export const CLAIM_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft', color: 'default' as const },
  { value: 'processing', label: 'Processing', color: 'warning' as const },
  { value: 'failed', label: 'Failed', color: 'error' as const },
  { value: 'scrubbing', label: 'Processing', color: 'warning' as const },
  { value: 'ready', label: 'Ready', color: 'success' as const },
  { value: 'submitted', label: 'Submitted', color: 'info' as const },
  { value: 'acknowledged', label: 'Received', color: 'primary' as const },
  { value: 'accepted', label: 'Accepted', color: 'success' as const },
  { value: 'rejected', label: 'Rejected', color: 'error' as const },
  { value: 'paid', label: 'Paid', color: 'success' as const },
  { value: 'partially_paid', label: 'Partial Pay', color: 'warning' as const },
  { value: 'denied', label: 'Denied', color: 'error' as const },
  { value: 'reversed', label: 'Reversed', color: 'warning' as const },
] as const;

// Status options by tab
export const STATUS_OPTIONS_BY_TAB = {
  unbilled: ENCOUNTER_STATUS_OPTIONS,
  claims: CLAIM_STATUS_OPTIONS,
  remittances: [] as const,
} as const;

// Get status color for display
export function getStatusColor(
  tab: 'unbilled' | 'claims',
  status: string,
): 'primary' | 'success' | 'warning' | 'error' | 'info' | 'default' {
  const options = STATUS_OPTIONS_BY_TAB[tab];
  const option = options.find(opt => opt.value === status);
  return option?.color || 'default';
}
